module.exports = __webpack_public_path__ + "img/btn-download@2x.14c2f189.png";